import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { slice, role } from "../../enums/index";
 import {APP_CONSTANTS} from "../../constants";
import {  IStation, IUser } from "../../interfaces";
import { ICenter } from "../../interfaces";

// storageEncryption();
export interface IAuthState {
  accessToken: string | null;
  isTokenExpired: boolean;
  isRefreshingToken: boolean;
  refreshToken: string | null;
  credentialSecrets?: Array<any>;

  currentCenter: Partial<ICenter> | null;
  currentBox: Partial<IStation> | null;
  user: IUser | null;
  access?: any;
  isConnected: boolean;
}

const getInitialState = (): IAuthState => {
  const storedUserInfos: any = localStorage.getItem(
    `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}user`
  )
    ? localStorage.getItem(`${APP_CONSTANTS.LOCALSTORAGE_PREFIX}user`)
    : null;

  const storedCurrentCenter = localStorage.getItem(
    `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}center`
  );
  const storedCurrentBox = localStorage.getItem(
    `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}box`
  );

  const storedToken = localStorage.getItem(
    `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}token`
  );

  const storedRefreshToken = localStorage.getItem(
    `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}refreshToken`
  );

  const initialState: IAuthState = {
    accessToken: storedToken,
    isTokenExpired: false,
    isRefreshingToken: false,
    access: [],
    currentBox: storedCurrentBox,
    currentCenter: storedCurrentCenter,
    refreshToken: storedRefreshToken,
    user: storedUserInfos,
    isConnected: false,
  };

  return initialState;
};

const authSlice = createSlice({
  name: slice.AUTH,
  initialState: getInitialState(),
  reducers: {
    setSession: (
      state,
      action: PayloadAction<{
        user: IUser;
        accessToken: string;
        refreshToken: string;
        currentCenter: ICenter | null;
        currentBox: IStation | null;
      }>
    ) => {

      const { user, accessToken, refreshToken, currentCenter, currentBox } =
        action.payload;

      state.isTokenExpired = false;
      state.user = user;
      state.currentCenter = currentCenter;
      state.currentCenter = currentBox;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.isConnected = true;
      //
      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}user`,
        JSON.stringify(action.payload.user)
      );
      //

      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}token`,
        accessToken
      );
      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}refreshToken`,
        refreshToken
      );

      // for security purposes should be getted from server to check with team backend
      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}center`,
        "null"
      );
      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}box`,
        "null"
      );
 
      // redirect on success
      if (user) {
        if ([role.GENERALIST, role.HOST].includes(user.roles[0].name))
          window.location.pathname = APP_CONSTANTS.ROUTES.PATIENTS_LIST;
        if (user.roles[0].name === role.SPECIALIST)
          window.location.pathname = '/';
      }
    },
    refreshSession: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
      }>
    ) => {
      const { accessToken, refreshToken } = action.payload;

      state.isTokenExpired = false;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.isConnected = true;

      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}token`,
        accessToken
      );
      localStorage.setItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}refreshToken`,
        refreshToken
      );
    },
    setIsExpiredToken: (
      state,
      action: PayloadAction<{ isExpired: boolean }>
    ) => {
      state.isTokenExpired = action.payload.isExpired;
    },
    setIsRefreshingToken: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingToken = action.payload;
    },

    logOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isConnected = false;
      state.isTokenExpired = true;

      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}token`
      );
      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}credentialSecrets`
      );
      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}user`
      );
      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}refreshToken`
      );

      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}center`
      );
      localStorage.removeItem(
        `${APP_CONSTANTS.LOCALSTORAGE_PREFIX}box`
      );
    },
  },
});

export const {
  setSession,
  refreshSession,
  setIsExpiredToken,
  setIsRefreshingToken,
  logOut,
} = authSlice.actions;

export default authSlice.reducer;
